import { Box, Button } from "@material-ui/core";
import React from "react";
import { useI18n } from "../../../../../hooks/useI18n";

export interface StepButtonsProps {
  backDisabled?: boolean;
  nextDisabled?: boolean;
  lastStep?: boolean;
  onClickNext: () => void;
  onClickBack?: () => void;
}

export const StepButtons = ({
  backDisabled = false,
  nextDisabled = false,
  lastStep = false,
  onClickNext,
  onClickBack
}: StepButtonsProps) => {
  const { t } = useI18n();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        pt: 2,
        alignSelf: "flex-end",
        width: "100%"
      }}
    >
      <Button
        disabled={backDisabled}
        onClick={() => {
          onClickBack != undefined ? onClickBack() : {};
        }}
      >
        {t("common.actions.back")}
      </Button>
      <Box sx={{ flex: "1 1 auto" }} />
      <Button
        disabled={nextDisabled}
        color="primary"
        onClick={() => onClickNext()}
      >
        {lastStep ? t("common.messages.finish") : t("common.actions.next")}
      </Button>
    </Box>
  );
};
